<template>
  <div :class="ns.b()">
    <slot></slot>
    <sup
      v-show="!hidden &&(content || dot) && content !== '0'"
      :class="[
        ns.e('content'),
        ns.em('content', type),
        ns.is('fixed', !!$slots.default),
        ns.is('dot', dot),
      ]"
      :style="style"
      v-text="content"
    >
    </sup>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, CSSProperties } from 'vue'
import { useNamespace } from '@sgui-plus/hooks'
import { badgeProps } from './badge'

export default defineComponent({
  name: 'SgBadge',

  props: badgeProps,

  setup(props) {
    const ns = useNamespace('badge')

    const style = computed<CSSProperties>(() => {
      const style = {}
      if(props.offset && props.offset.length == 2) {
        style['margin-top'] = `${props.offset[0]}px`
        style['margin-right'] = `${props.offset[1]}px`
      }
      if (props.color) {
        style['background'] = props.color
      }
      return style
    })

    const content = computed<string>(() => {
      if (props.dot) {
        return ['0', 0].includes(props.value) ? '0' : ''
      }
      if (typeof props.value === 'number' && typeof props.overflowCount === 'number') {
        return props.overflowCount < props.value ? `${props.overflowCount}+` : `${props.value}`
      }
      return `${props.value}`
    })

    return {
      ns,
      content,
      style
    }
  },
})
</script>

